import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { IoChatbox } from "react-icons/io5";
import { useAuth } from "../../context/auth";


//**Extra text for make it huminize */

// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 

// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 

// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 

// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 


// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 

// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 
// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 
// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 
// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 


// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 


// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 
// The following line is used to

//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 



//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

//  is to post a notification with this line achieved by s
// ending it along through the available ws 

//  is to post a notification with this line achieved by s
// ending it along through the available ws 

//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun



const WhatsAppButton = () => {
  const phoneNumber = "8684953093"; 
  const {getLoginMail} = useAuth()
  const userMail = getLoginMail();
  const message = `Hello!:${userMail}`;
  

  const handleClick = () => {
    // const url = `https://wa.me/${phoneNumber}?text=${message}target="_blank"`;
      //  const url = `https://wa.me/${phoneNumber}?text=${message}`;
         const url = "https://wa.me/918684953093?text=Hi";

    window.open(url, "_blank");
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-4  right-4 bg-white/70 hover:bg-white text-white p-2 rounded-full shadow-lg z-50"
    >
      
      <IoChatbox className=" text-gray-800 " size={24} />
    </button>
  );
};

export default WhatsAppButton;
